export enum CharacterProfession {
    Runeblade = 'Runeblade',
    Aethermancer = 'Aethermancer',
    Lifeweaver = 'Lifeweaver',
}
